<template>
  <div class="grid find-sk-modal">
    <Toast />

    <div class="col-12 mb-2">
      <div class="mb-6">
        <span class="p-float-label">
          <AutoComplete
            id="documentNumber"
            class="w-full"
            :disabled="!documentList"
            :suggestions="filteredDocuments"
            :dropdown="true"
            field="BL_NUMBER"
            forceSelection
            v-model="selectedDocument"
            @complete="searchDocument($event)"
          />
          <label for="documentNumber">Choose B/L Number</label>
        </span>
      </div>

      <div class="grid">
        <div class="col-12 md:col-6">
          <Button
            v-if="!loading"
            class="w-full justify-content-center text-center p-button-success mr-2"
            :disabled="!selectedDocument"
            @click="handleSave"
          >
            <span class="uppercase font-bold">Save</span>
          </Button>
          <Button
            v-else
            class="w-full justify-content-center text-center p-button-success mr-2"
            disabled
          >
            <span class="uppercase font-bold">Saving...</span>
          </Button>
        </div>
        <div class="col-12 md:col-6">
          <Button
            class="w-full justify-content-center text-center p-button-secondary"
            @click="$emit('on-close')"
          >
            <span class="uppercase font-bold">Cancel</span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, defineProps, defineEmits } from "vue";
import { getBLDocuments } from "@/service/InvoiceProxyExportServices";

const props = defineProps(["dbInstance", "vendorId"]);
const emit = defineEmits(["on-save"]);

const selectedDocument = ref(null);
const documentList = ref(null);
const filteredDocuments = ref(null);
const loading = ref(false);

onMounted(() => {
  fetchBLDocuments();
});

const fetchBLDocuments = async () => {
  const res = await getBLDocuments(props.dbInstance, props.vendorId);

  if (res.status === 200) {
    documentList.value = res.data.data;
  }
};

const searchDocument = (event) => {
  if (!event.query.trim().length) {
    filteredDocuments.value = [...documentList.value];
    return;
  }

  filteredDocuments.value = documentList.value.filter((item) =>
    item.BL_NUMBER.toLowerCase().includes(event.query.toLowerCase())
  );
};

const handleSave = () => {
  emit("on-save", selectedDocument.value);
};
</script>
